import FreeSpinsRecord from 'integration/freespin-record';
import { DOServerKeys } from 'names/do-names';
import GameState from 'slotworks/model/game-state';
import { Exit } from 'slotworks/state-machine/data/exit';
import Decision from 'slotworks/state-machine/decisions/decision';

export default class IsFreeSpinCheck extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const r = record.getResultsOfType(FreeSpinsRecord) as FreeSpinsRecord[];
        const freespinRecord = r[0];

        let triggered = false;
        if (freespinRecord) {
            triggered = freespinRecord.triggering_game == DOServerKeys.FREESPIN || freespinRecord.gameName == DOServerKeys.FREESPIN;
            if (freespinRecord.beenPaid || freespinRecord.recover == true) {
                triggered = false;
            }
        } else {
            triggered = false;
        }
        return triggered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./src/desicions/freespin-check.ts